import { Col, message } from "antd";
import { Icons } from "../assets/icons";
import PageHeader from "../components/ui/PageHeader";
import { ICON_SIZE } from "../repository/data.default";
import FooterQuoteCard from "../components/ui/FooterQuoteCard";
import SatageSubHeader from "../components/ui/SatageSubHeader";
import SectionTwo from "../components/ManagementReviewSections/SectionTwo";
import ViewReportCard from "../components/ui/ViewReportCard";

const footerText = (
  <p>
    Management & Review closes the wellbeing cycle: leadership steps back,
    looks across outcomes, open actions, policy coverage and training
    attendance, and sets the next review date. The decisions recorded here
    seed the next cycle's planning.
  </p>
);

const stepsList = (
  <>
    <li>a. Leadership review summary</li>
    <li>b. Open and overdue actions</li>
    <li>c. Policy and training follow-up</li>
    <li>d. Key risk and progress findings</li>
    <li>e. Management decisions and next review date</li>
  </>
);

const overviewText = (
  <p>
    Welcome to the Management & Review Step. This step supports leadership
    review and management follow-up — reviewing outputs, actions, findings
    and company progress across the cycle, and setting decisions to carry
    into the next one.
  </p>
);

const viewReportCardText = `The Management Review Summary consolidates the leadership summary, open actions, policy and training follow-up, and the key risk and progress findings for the current cycle.`;

function ManagementReviewPage() {
  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <PageHeader
        stage={6}
        title={"MANAGEMENT & REVIEW"}
        icon={<Icons.TrophyIcon width={ICON_SIZE} height={ICON_SIZE} />}
      />
      <SatageSubHeader overviewText={overviewText} stepsList={stepsList} />
      <ViewReportCard
        title="MANAGEMENT REVIEW"
        text={viewReportCardText}
        btnName="view report"
        btnAction={() => message.info("This report is not yet available.")}
      />
      <SectionTwo />
      <FooterQuoteCard
        icon={<Icons.TrophyIcon width={350} height={350} />}
        text={footerText}
      />
    </Col>
  );
}

export default ManagementReviewPage;
